<template>

<div class="row jira-feature-headline jf-row">
      <div class="col-5">
        <div class="jfh-col metastory">

          <div class="icon">
            <img class="metastory-logo light" src="@/assets/ui/text-cursor.svg" style="width: 6px;">
            <img class="metastory-logo dark" src="@/assets/ui/text-cursor-white.svg" style="width: 6px;">
          </div>
          metastory Fields
        </div>
      </div>
      <div class="col-2 icon-snyc">

      </div>
      <div class="col-5">
        <div class="jfh-col jira">
          <div class="icon">
            <img src="@/assets/integrations/jira.svg" style="height: 16px;">
          </div>
          Jira Fields
        </div>
      </div>
    </div>

  <div class="row jira-feature-form jf-row">
    <div class="col-5">
      <div class="jf-checkbox">
        <CheckboxElement name="Summary" v-model="checked" disabled/>
        <div class="fp-label">
            <span class="icon"><LucideIcon icon="Type"/></span>
            <span>Title</span>
        </div>
      </div>
    </div>
    <div class="col-2 icon-snyc">
      <LucideIcon icon="RefreshCw"/>
    </div>
    <div class="col-5">
      <div class="fp-label fp-label-jira">
          <span class="icon"><img src="@/assets/integrations/jira.svg" alt="Jira" style="height: 16px;"/></span>
          <span>Summary</span>
      </div>
    </div>
  </div>

  <div class="row jira-feature-form jf-row">
    <div class="col-5">
      <div class="jf-checkbox">
        <CheckboxElement name="Description" v-model="checked" disabled/>
        <div class="fp-label">
            <span class="icon"><LucideIcon icon="FileText"/></span>
            <span>Description</span>
        </div>
      </div>
    </div>
    <div class="col-2 icon-snyc">
      <LucideIcon icon="RefreshCw"/>
    </div>
    <div class="col-5">
      <div class="fp-label fp-label-jira">
          <span class="icon"><img src="@/assets/integrations/jira.svg" alt="Jira" style="height: 16px;"/></span>
          <span>Description</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {CheckboxElement} from "@shared/components";

export default defineComponent({
  name: 'JiraFieldsMapping',
  components: {
    CheckboxElement,
  },
  data() {
    return {
      checked:true,
    };
  },
  methods: {
  },
});
</script>

<style lang="scss" scoped>

  .jf-row{
    .col-5 {
      flex: 0 0 auto;
      width: 48%;
    }
    .col-2 {
      flex: 0 0 auto;
      width: 2.66667%;
    }
  }


  .jira-feature-form{
    margin-bottom: 10px;
    .icon-snyc{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: var(--fs-14);
      color: var(--neutral-200);
    }
    .jf-checkbox{
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
    .fp-label{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 40px;
      width: 100%;
      padding: 0 10px;
      border-radius: $br-sm;
      font-size: var(--fs-14);
      background: var(--light-300);
      border: 1px solid var(--light-300);
      .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
      }
      &.fp-label-jira{
        background: var(--light-300);
      border: 1px solid var(--light-300);
        .icon{
          color: var(--jira-100);
        }
      }
    }
  }

</style>
